<template>
  <a-modal
    :visible="visible"
    title="Progress Logs"
    @cancel="$emit('close')"
    @ok="$emit('close')"
    okText="Close"
    width="1000px"
  >
    <a-spin :spinning="loading">
      <a-table
        :rowKey="record => record.id"
        :dataSource="logs"
        :columns="displayColumns"
        size="middle"
      >
        <template slot="section" slot-scope="sectionId">
        <div class="font-weight-bold">
        <span>
        {{ getSectionName(sectionId) }}
        </span>
        </div>
        </template>

        <template slot="period" slot-scope="period">
            <div class="font-weight-bold">{{ formatPeriod(period) }}</div>
        </template>

      <template slot="status" slot-scope="status">
        <a-tag :color="getStatusColor(status)" :style="getStatusStyle(status)">
          {{ status || 'Not Started' }}
        </a-tag>
      </template>

        <template slot="details" slot-scope="details">
            <div class="font-weight-bold">{{ details }}</div>
        </template>

        <template slot="remarks" slot-scope="remarks">
            <div class="font-weight-bold">{{ remarks }}</div>
        </template>

        <template slot="date" slot-scope="date">
            <div class="font-weight-bold">{{ formatDate(date) }}</div>
        </template>

        <!-- Actions -->
        <template slot="actions" slot-scope="text, record">
          <div class="text-nowrap">
            <a href="javascript:;" class="btn btn-sm btn-info btn-with-addon mr-2"
              @click="handleEdit(record)">
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
              Edit
            </a>
            <a href="javascript:;" class="btn btn-sm btn-danger btn-with-addon"
              @click="handleDelete(record)">
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete
            </a>
          </div>
        </template>
      </a-table>
    </a-spin>
  </a-modal>
</template>

<script>
import moment from 'moment'
export default {
  name: 'ViewLogsModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      logs: [],
      sections: [],
      loading: false,
      columns: [
        { title: 'Section',
          dataIndex: 'section_id',
          key: 'section_id',
          scopedSlots: { customRender: 'section' },

        },
        { title: 'Period',
          dataIndex: 'period',
          key: 'period',
          scopedSlots: { customRender: 'period' },
        },
        { title: 'Date',
          dataIndex: 'date',
          key: 'date',
          scopedSlots: { customRender: 'date' },
        },
        { title: 'Status',
          dataIndex: 'status',
          key: 'status',
          scopedSlots: { customRender: 'status' },
        },
        { title: 'Details',
          dataIndex: 'details',
          key: 'details',
          scopedSlots: { customRender: 'details' },
          width: '25%',
        },
        { title: 'Remarks',
          dataIndex: 'remarks',
          key: 'remarks',
          scopedSlots: { customRender: 'remarks' },
          width: '25%',
        },
        {
          title: 'Actions',
          key: 'actions',
          scopedSlots: { customRender: 'actions' },
        },
      ],
    }
  },
  computed: {
    displayColumns() {
      if (this.readonly) {
        return this.columns.filter(c => c.key !== 'actions')
      }
      return this.columns
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.fetchSections()
        this.fetchLogs()
      }
    },
  },
  methods: {
    getStatusColor(status) {
      const s = (status || '').toLowerCase()
      if (s === 'completed') return 'green'
      if (s === 'in progress') return 'blue'
      if (s === 'started') return 'orange'
      return '#595959'
    },
    getStatusStyle(status) {
      const color = this.getStatusColor(status)
      if (color === '#595959') {
        return { color: '#ffffff', backgroundColor: '#595959', borderColor: '#595959' }
      }
      return {}
    },
    getSectionName(id) {
      const sec = this.sections.find(s => s.id === id)
      return sec ? sec.name : `ID: ${id}`
    },
    formatPeriod(period) {
      if (!period) return '-'
      const s = ['th', 'st', 'nd', 'rd']
      const v = period % 100
      return period + (s[(v - 20) % 10] || s[v] || s[0]) + ' Period'
    },
    formatDate(date) {
      if (!date) return '-'
      return moment(date).format('DD-MM-YYYY')
    },
    fetchLogs() {
      if (!this.item) return
      this.loading = true
      this.$http
        .get('/api/lesson-plan/teacher/progress', {
          params: {
            topic_id: this.item.type === 'topic' ? this.item.id : null,
            sub_topic_id: this.item.type === 'sub-topic' ? this.item.id : null,
            section_id: this.item.section_id || null,
          },
        })
        .then(({ data }) => {
          this.logs = data.data
        })
        .catch(err => {
          console.error('Failed to fetch logs', err)
          this.$notification.error({ message: 'Failed to load progress logs' })
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchSections() {
      this.$http.get('/api/section')
        .then(({ data }) => {
          this.sections = data.data
        })
        .catch(() => {
          this.$notification.error({ message: 'Failed to load sections' })
        })
    },
    handleEdit(record) {
      this.$emit('edit-log', record) // delegate edit to parent
    },
    handleDelete(record) {
      this.$confirm({
        title: 'Are you sure delete this log?',
        onOk: () => {
          this.$http
            .delete(`/api/lesson-plan/teacher/progress/${record.id}`)
            .then(() => {
              this.$message.success('Log deleted')
              this.fetchLogs()
            })
            .catch(() => {
              this.$notification.error({ message: 'Delete failed' })
            })
        },
      })
    },
  },
}
</script>
